import { uuid } from 'uuidv4';

/**
 * Given a File object, generate a UUID-based file key for use in S3, using the original file
 * extension. For example, a file with the a `.csv` extension would generate an ID like:
 * '100edcd0-2f4d-44f9-a047-547cb9d8b23c.csv'
 * If an extension cannot be read from the filename, a plain UUID is returned instead, like:
 * '100edcd0-2f4d-44f9-a047-547cb9d8b23c'
 */
export const generateUuidFileKeyForS3 = (file: File): string => {
    const uniqueId = uuid();
    const extensionMatch = file.name.match(/(.\w+)$/);

    if (extensionMatch !== null) {
        return `${uniqueId}${extensionMatch[1]}`;
    }

    return uniqueId;
};
